import { useContext } from "react";

import { QuizModuleId } from "@common";
import { QuizModuleContext } from "@natklok/contexts/quizModuleContext";

const useCurrentQuizModule = (): QuizModuleId => {
  const { currentQuizModule } = useContext(QuizModuleContext);
  return currentQuizModule;
};

export default useCurrentQuizModule;
